module.exports = __webpack_public_path__ + "static/media/error-robot.36eb23a3.png";